function clearBtns(handle) {
  var productButtons = document.querySelectorAll('wishlist-button[data-product-handle="' + handle + '"]');
  productButtons.forEach(function(button) {
    if (button.querySelector('button').classList.contains('swym-added') && button.querySelector('button').classList.contains('is-active')) {
      button.querySelector('button').classList.remove('swym-added', 'is-active', 'swym-adding', 'disabled');
      button.querySelector('button').setAttribute("aria-label", "Add to wishlist");
    }
  });
}

function checkWishlist() {
  var swymProducts = JSON.parse(localStorage.getItem('swym-products')) || {};
  var wishlistHandles = localStorage.getItem('wishlist-handles') || '';

  var handlesArray = wishlistHandles.split(',');

  handlesArray.forEach(function (handle) {
    var foundProduct = false;

    for (var i = 0; i < swymProducts.all.length; i++) {
      var product = swymProducts.all[i];
      var productHandle = product.dt;
      if(productHandle) {
        var productButtons = document.querySelectorAll('wishlist-button[data-product-handle="' + productHandle + '"]');
        productButtons.forEach(function(button) {
          button.querySelector('button').classList.add('swym-added', 'is-active', 'swym-adding', 'disabled');
          button.querySelector('button').setAttribute("aria-label", "Remove from wishlist");
        });
      }
      if (productHandle === handle) {
        foundProduct = true;
        break;
      }
    }

    if (!foundProduct) {

      clearBtns(handle);

      var index = handlesArray.indexOf(handle);
      if (index > -1) {
        handlesArray.splice(index, 1);
      }
    }
  });

  localStorage.setItem('wishlist-handles', handlesArray.join(','));
}

document.addEventListener("DOMContentLoaded", function(event){
  checkWishlist();
});

const wishlistButtons = document.querySelectorAll('.product-card__wishlist-button button');

wishlistButtons.forEach(button => {
  button.addEventListener('click', function() {
    checkWishlist();
    if(button.classList.contains('swym-added') && button.classList.contains('is-active')) {
      button.classList.remove('swym-added');
      button.classList.remove('is-active');
      button.classList.remove('swym-adding');
      button.classList.remove('disabled');
    } else {
      button.classList.add('swym-added');
      button.classList.add('is-active');
      button.classList.add('swym-adding');
      button.classList.add('disabled');
    }
  })
});



function mainWishlistButtonCheck(handle) {
  var mainWishlistButton = document.querySelector('.main-product__wishlist-button button');
  var mainWishlistHandle = document.querySelector('.main-product__wishlist-button').getAttribute('data-product-handle');
  var mainWishlistHandleBtn = document.querySelector('.main-product__wishlist-button');
  
  checkWishlist();
  
  if(handle) {
    if(mainWishlistHandle === handle) {
      var mainWishlistHandleButton = mainWishlistHandleBtn.querySelector('button');
      if(mainWishlistHandleButton.classList.contains('swym-added') && mainWishlistHandleButton.classList.contains('is-active')) {
        mainWishlistHandleButton.classList.remove('swym-added');
        mainWishlistHandleButton.classList.remove('is-active');
        mainWishlistHandleButton.classList.remove('swym-adding');
        mainWishlistHandleButton.classList.remove('disabled');
        mainWishlistHandleButton.setAttribute("aria-label", "Add to wishlist");
      } else {
        mainWishlistHandleButton.classList.add('swym-added');
        mainWishlistHandleButton.classList.add('is-active');
        mainWishlistHandleButton.classList.add('swym-adding');
        mainWishlistHandleButton.classList.add('disabled');
        mainWishlistHandleButton.setAttribute("aria-label", "Remove from wishlist");
      }
    }
  } else {
    if(mainWishlistButton.classList.contains('swym-added') && mainWishlistButton.classList.contains('is-active')) {
      mainWishlistButton.classList.remove('swym-added');
      mainWishlistButton.classList.remove('is-active');
      mainWishlistButton.classList.remove('swym-adding');
      mainWishlistButton.classList.remove('disabled');
      mainWishlistButton.setAttribute("aria-label", "Add to wishlist");
    } else {
      mainWishlistButton.classList.add('swym-added');
      mainWishlistButton.classList.add('is-active');
      mainWishlistButton.classList.add('swym-adding');
      mainWishlistButton.classList.add('disabled');
      mainWishlistButton.setAttribute("aria-label", "Remove from wishlist");
    }
  }
  
}

var mainWishlistButton = document.querySelector('.main-product__wishlist-button button');
if(mainWishlistButton) {
  mainWishlistButton.addEventListener('click', function() {
    checkWishlist();
    mainWishlistButtonCheck();
  })
}

const productCards = document.querySelectorAll('.product-card');

productCards.forEach(card => {
  const wishlistButton = card.querySelector('.product-card__wishlist-button button');
  const quickViewButton = card.querySelector('.product-card__form__btn');
  
  card.addEventListener('mouseenter', function() {
    wishlistButton.style.opacity = 1;
    quickViewButton.style.opacity = 1;
  });
  
  card.addEventListener('mouseleave', function() {
    wishlistButton.style.opacity = 0;
    quickViewButton.style.opacity = 0;
  });

  quickViewButton.addEventListener('click', function() {
    checkWishlist();

    setTimeout(() => {
      var quickViewModal = document.querySelector('.product-quickview');
      var quickViewMainBtn = document.querySelector('.main-product__wishlist-button button');
      var quickViewMainBtnHandle = document.querySelector('.main-product__wishlist-button').getAttribute('data-product-handle');
      var quickViewModalClose = quickViewModal.querySelector('.product-quickview__close');
      var quickViewModalOverlay = quickViewModal.querySelector('.product-quickview__overlay').classList;

      if(wishlistButton.classList.contains('swym-added') && wishlistButton.classList.contains('is-active')) {
        quickViewMainBtn.classList.add('swym-added', 'is-active');
      }

      quickViewMainBtn.addEventListener('click', function() {
        checkWishlist();
        if(quickViewMainBtn.classList.contains('swym-added') && quickViewMainBtn.classList.contains('is-active')) {
          clearBtns(quickViewMainBtnHandle);  
        } else {
          quickViewMainBtn.classList.add('swym-added', 'is-active')
        }
      })
      quickViewModal.addEventListener('click', function(target) {
        if(target.target.className === quickViewModalOverlay.value) {
          checkWishlist();
        }
      })
      quickViewModalClose.addEventListener('click', function() {
        checkWishlist();
      })
    }, 500);

  })

});

const swymWishlistBtn = document.querySelector('.swym-wishlist')

if (swymWishlistBtn) {
  swymWishlistBtn.addEventListener('click', function() {
    checkWishlist();

    setTimeout(function() {

      var deleteButtons = document.querySelectorAll('.swym-delete-btn');

      deleteButtons.forEach(function(button) {
        button.addEventListener('click', function() {
  
          var productLabel = button.getAttribute('aria-label').replace('Delete ', '');
          clearBtns(productLabel);
  
          var mainWishlistButton = document.querySelector('.main-product__wishlist-button button');
          if(mainWishlistButton) {
            mainWishlistButtonCheck(productLabel);
          }

        });
      });

      const swymModal = document.querySelector('.swym-modal');
    
      swymModal.addEventListener('click', function() {
        checkWishlist();
      });

      const swymCloseBtn = document.querySelector('.swym-close-btn');
    
      swymCloseBtn.addEventListener('click', function() {
        checkWishlist();
      });

      const swymEmptyBtn = document.querySelector('.swym-empty-wishlist-continue-btn');
      if(swymEmptyBtn) {
        swymEmptyBtn.addEventListener('click', function() {
          checkWishlist();
        });
      }

    }, 100);
  });
}
